import { EnvironmentNames } from 'libs/core/src/lib/constants/fund/environments';
import { WIRING_INSTRUCTIONS_SWISS } from 'libs/portal/src/lib/_core/constants/wiring-instructions';

export const environment = {
  production: false,
  envName: 'tb-staging',
  clarityTrackingId: 'vu0msg7u1k',
  tenantId: 'swiss_staging_merged',
  tenantName: 'TB',
  apiUrl: 'https://staging-v2.givingspace.trustbridgeglobal.com/api',
  apiBaseUrl: 'https://staging-v2.givingspace.trustbridgeglobal.com',
  logLevel: 'info',
  enableDebugTools: false,
  enableAuth: true,
  keycloak: {
    issuer: 'https://test.sso.benevatech.com/auth/realms/GivingSpace2',
    clientId: 'swiss_staging-public',
    responseType: 'code',
    scope: 'openid profile email links',
    showDebugInformation: false,
    disableAtHashCheck: true,
    sessionChecksEnabled: true,
    useSilentRefresh: true
  },
  fund: {
      tenantId: 'swiss_staging_merged',
      server: 'https://staging-v2.trustbridgeglobal.com/api',
      url: 'https://staging-v2.trustbridgeglobal.com',
      contact: 'https://www.trustbridgeglobal.com/contact-us',
      primaryColor: 'rgb(168, 28, 7)',
      secondaryColor: 'rgb(243, 226, 223)',
      ternaryColor: 'rgb(168, 28, 7)',
      logo: 'assets/logos/tb.png',
      publicLogo: 'assets/logos/tb-public.png',
      lightDonateNowButtonLink:
        'https://5432341.app.netsuite.com/core/media/media.nl?id=425986&c=5432341&h=1mbtBQFEwVAtBRaoFfeWHwwCsvUzId6x_hwoHh_JVOsLdNyO',
      darkDonateNowButtonLink:
        'https://5432341.app.netsuite.com/core/media/media.nl?id=425985&c=5432341&h=v7eBj6dwbUKmDb1S9y6NJOyGV_WwAxNMQimOf1HlbkAsGVtm',
      lightDonateNowButtonSrc: 'assets/donate-buttons/swiss_light_donate_button.png',
      darkDonateNowButtonSrc: 'assets/donate-buttons/swiss_dark_donate_button.png',
      favicon:
        'https://images.squarespace-cdn.com/content/5ae9d1402714e568d499f07e/1526729411980-7A3HV54PI4EPUGJ4I7D3/logo.png?format=100w&content-type=image%2Fpng',
      wiringInstructions: WIRING_INSTRUCTIONS_SWISS,
      eftInstructions: null,
      stripeKey:
        'pk_test_51HuFiFEHLm9wiVf0xjLkqQAuqHA1m1tLNnCZD5sOENauhNkeFMKQYJWaUL89tTW5VBOxZFheVcyNxfjhucthVHRQ00aLWzSkWB',
      homeLink: 'https://www.trustbridgeglobal.com/',
      blog: 'http://www.trustbridgeglobal.com/blog',
      privacyPolicy: 'https://www.trustbridgeglobal.com/privacy',
      terms: 'https://www.trustbridgeglobal.com/terms',
      mailTo: 'admin@trustbridgeglobal.com',
      name: 'TrustBridge Global Foundation',
      gsUrl: 'https://staging.givingspace.trustbridgeglobal.com',
      // Frontend Logic
      environmentName: EnvironmentNames.SWISS,
      languages: ['en-swiss'],
      production: false,
      multiCurrency: true,
      redirectSourceUrl: null,
      backendClientId: 'swiss_staging-backend',
      authConfig: {
        issuer: 'https://test.sso.benevatech.com/auth/realms/GivingSpace2',
        redirectUri: window.location.origin,
        clientId: 'swiss_staging-public',
        responseType: 'code',
        scope: 'openid profile email links',
        showDebugInformation: true,
        sessionChecksEnabled: true,
      },
      signatureApiKey: 'fa118d0b-c1aa-4c83-8fd0-ee84b80bff72',
    },
};
